module.exports = __webpack_public_path__ + "static/media/powered-by-hatch.c5a0b3b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/powered-by-hatch.svg
// module id = 322
// module chunks = 0